import { Navigate, Route, Routes, useLocation } from "react-router-dom";

import {
  DoctorNotes,
  DocumentCenterOverview,
  EditProfile,
  Home,
  LabsDetails,
  MedicalRecordsDetails,
  MyProfile,
  PrescriptionsDetails,
} from "@/app/screens";
import { ROUTES } from "../constants";
import { ModalsRoutesWrapper } from "./modals-routes-wrapper";
import { PortalRoutesWrapper } from "./portal-routes-wrapper";

/**
 * @deprecated These are the pending routes to move to their own router in the `features` folder.
 */
export const LegacyRouter = () => {
  const location = useLocation();
  const { previousLocation } = (location.state ?? {}) as {
    previousLocation?: Location;
  };

  // const hasActiveSubscription = usePortalUserStore(
  //   (state) => state.hasActiveSubscription,
  // );

  return (
    <>
      <Routes location={previousLocation ?? location}>
        <Route element={<PortalRoutesWrapper />}>
          <Route element={<MyProfile />} path={ROUTES.PROFILE.OVERVIEW} />
          <Route element={<EditProfile />} path={ROUTES.PROFILE.EDIT} />
          <Route element={<Home />} path={ROUTES.HOME} />

          <Route
            element={<DocumentCenterOverview />}
            path={ROUTES.DOCUMENT_CENTER.OVERVIEW}
          />
          <Route element={<LabsDetails />} path={ROUTES.DOCUMENT_CENTER.LABS} />

          <Route
            element={<DoctorNotes />}
            path={ROUTES.DOCUMENT_CENTER.DOCTOR_NOTES}
          />
          <Route
            element={<PrescriptionsDetails />}
            path={ROUTES.DOCUMENT_CENTER.PRESCRIPTIONS}
          />
          <Route
            element={<MedicalRecordsDetails />}
            path={ROUTES.DOCUMENT_CENTER.MEDICAL_RECORDS}
          />

          {/* {hasActiveSubscription && (
            <Route
              element={<LevelsRxResources />}
              path={ROUTES.DOCUMENT_CENTER.LEVELS_RX_RESOURCES}
            />
          )} */}
        </Route>

        <Route path="*" element={<Navigate replace to={ROUTES.BASE} />} />
      </Routes>

      <ModalsRoutesWrapper />
    </>
  );
};
